import {createAction} from 'Shared/utilities/actionCreator';
import {Async, Empty, Loading} from 'Core/models/Async';
import {ProducerCompliancePolicyAttachment} from 'Agent/AgentInformation/models/ProducerCompliancePolicyAttachment';

export enum ProducerCompliancePolicyAttachmentsActionType {
  GET_PRODUCER_COMPLIANCE_POLICY_ATTACHMENTS = 'producerCompliancePolicy/GET_PRODUCER_COMPLIANCE_POLICY_ATTACHMENTS',
  LOAD_PRODUCER_COMPLIANCE_POLICY_ATTACHMENTS = 'producerCompliancePolicy/LOAD_PRODUCER_COMPLIANCE_POLICY_ATTACHMENTS',
  CLEAR = 'producerCompliancePolicy/CLEAR',
}

export const clear = () => createAction(ProducerCompliancePolicyAttachmentsActionType.CLEAR);
export const getProducerCompliancePolicyAttachments = (encryptedIdentifier: string) =>
  createAction(ProducerCompliancePolicyAttachmentsActionType.GET_PRODUCER_COMPLIANCE_POLICY_ATTACHMENTS, {
    encryptedIdentifier,
  });
export const loadProducerCompliancePolicyAttachments = (attachments: Async<ProducerCompliancePolicyAttachment[]>) =>
  createAction(ProducerCompliancePolicyAttachmentsActionType.LOAD_PRODUCER_COMPLIANCE_POLICY_ATTACHMENTS, {
    attachments,
  });

type ProducerCompliancePolicyAttachmentsState = Async<ProducerCompliancePolicyAttachment[]>;
const DEFAULT_STATE: ProducerCompliancePolicyAttachmentsState = new Empty();

type ProducerCompliancePolicyAction =
  | ReturnType<typeof clear>
  | ReturnType<typeof getProducerCompliancePolicyAttachments>
  | ReturnType<typeof loadProducerCompliancePolicyAttachments>;

export default (
  state: ProducerCompliancePolicyAttachmentsState = DEFAULT_STATE,
  action: ProducerCompliancePolicyAction
): ProducerCompliancePolicyAttachmentsState => {
  switch (action.type) {
    case ProducerCompliancePolicyAttachmentsActionType.CLEAR:
      return DEFAULT_STATE;
    case ProducerCompliancePolicyAttachmentsActionType.GET_PRODUCER_COMPLIANCE_POLICY_ATTACHMENTS:
      return new Loading();
    case ProducerCompliancePolicyAttachmentsActionType.LOAD_PRODUCER_COMPLIANCE_POLICY_ATTACHMENTS:
      return action.payload.attachments;
    default:
      return state;
  }
};
